import { EasterEggPage } from "@features/easter-egg";

/**
 * `/` serves the easter egg, for now.
 *
 * It is meant to sit behind a link rather than be the front door, but that swap
 * waits until after the MVP launch — the MVP is defined in the Figma file. Until
 * then this is the landing page in everything but name, and the unit and e2e
 * suites test it as one.
 *
 * When the real landing page lands: mount it here, and give the easter egg a
 * route of its own for whatever links to it.
 */
export default function App() {
  return <EasterEggPage />;
}
